module.exports = __webpack_public_path__ + "static/media/nexo-earn.2.d2bcc870.png";